// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__2jhjd","gridSystem":"styles_gridSystem__ORNnc","boxName":"styles_boxName__LkRFA","createOwn":"styles_createOwn__H6zRI"};